import { HeaderMall9 } from "../../../../publicComponent/Header";
import Navigator from "../../../../publicComponent/h5/Navigator";
import WhiteSpec from "../../../../publicComponent/h5/WhiteSpec";
import FixedBar from "../../../../publicComponent/h5/FixedBar";
import BookingDetailContext, {
  BookingDetailController,
  useBookingDetailContext,
} from "../../../../reducer/moduleReducer/bookingDetail";
import { useEffect } from "react";
import Select from "../../../../publicComponent/Select";
import Modal from "../../../../publicComponent/Modal";
import AddBookingButton from "../../../../reducer/moduleReducer/bookingDetail/components/AddBookingButton";
import Radio from "../../../../publicComponent/Radio";
import { getI18n,useTranslation } from "react-i18next";
import ImgsSwiper from "./ImgsSwiper";

function BookingTimeBlock({ data, handle }) {
  const { state } = useBookingDetailContext();
  const { t } = useTranslation();
  let canBooking = Number(data.number);
  let isActive =
    state.query.reserveTime && state.query.reserveTime === data.bookingTime;

  return (
    <div
      onClick={() => {
        if (!data.disabled) {
          handle(data.bookingTime);
        }
      }}
      className={
        `inline-block rounded-[5px] border py-[12px] px-[20px] text-[14px] mr-[10px] mb-[10px] ` +
        `${
          canBooking && !data.disabled ? "cursor-pointer " : "opacity-[0.5] "
        }` +
        `${isActive ? "bg-[#333] text-white " : ""}` +
        `${
          data.disabled
            ? "bg-[#aaa] text-[#333] opacity-[0.5] cursor-not-allowed"
            : ""
        }`
      }
    >
      {data.bookingTime} ({canBooking ? t("可约") : t("约满")})
    </div>
  );
}

function BookingTimeModal({ handle, visible, query, detail, bookingTime }) {
  const { bookingDateHandle, bookingTimeHandle } = BookingDetailController();
  const { t } = useTranslation();

  return (
    <Modal
      visible={visible}
      onClose={handle}
      width={700}
      onConfirm={() => handle(false)}
      title={t("请选择预约到店时间")}
    >
      <div className="mdmax:hidden">
        <div className="flex items-center mt-[30px]">
          <label className="w-[100px] text-[14px]">{t("预约日期")}</label>
          <div className="flex-1">
            <Select
              placeholder={t("请选择预约时间")}
              onChange={bookingDateHandle}
              value={query.reserveDate}
              keyValue={{ label: "day", value: "day" }}
              controlStyle={{ marginBottom: 0 }}
              options={detail.timeList}
            />
          </div>
        </div>
        <div className="flex mt-[30px]">
          {bookingTime.length > 0 && (
            <div className="flex mb-[30px]">
              <label className="w-[100px] flex-none text-[14px] pt-[15px]">
                {t("预约时间")}
              </label>
              <div className="flex-1">
                {bookingTime.map((item, i) => (
                  <BookingTimeBlock
                    handle={bookingTimeHandle}
                    data={item}
                    key={i}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="md:hidden">
        <div className="divide-y divide-[#eee] px-[12px]">
          {detail.timeList &&
            detail.timeList.map((time, i) => (
              <div key={i}>
                <div
                  className="flex items-center justify-between px-[5px]"
                  onClick={() => bookingDateHandle(time)}
                >
                  <p className="text-[13px] text-[#666] py-[18px]">
                    {time.day}
                  </p>
                  <Radio checked={query.reserveDate === time.day} />
                </div>
                {query.reserveDate &&
                  query.reserveDate === time.day &&
                  bookingTime.length > 0 && (
                    <div>
                      {bookingTime.map((item, i) => {
                        let canBooking = Number(item.number);
                        let isActive =
                          query.reserveTime &&
                          query.reserveTime === item.bookingTime;
                        return (
                          <div
                            key={i}
                            style={{
                              opacity: canBooking ? 1 : 0.55,
                            }}
                            onClick={() => {
                              bookingTimeHandle(item.bookingTime);
                              handle(false);
                            }}
                            className={
                              `inline-block py-[4px] px-[5px] rounded-[5px] mb-[10px] mr-[5px] border border-[#ddd]` +
                              `${
                                canBooking
                                  ? "cursor-pointer "
                                  : "cursor-not-allowed opacity-[0.5] "
                              }` +
                              `${isActive ? "bg-[#333] text-white " : ""}`
                            }
                          >
                            {item.bookingTime} ({canBooking ? "可约" : "约满"})
                          </div>
                        );
                      })}
                    </div>
                  )}
              </div>
            ))}
        </div>
      </div>
    </Modal>
  );
}

function BookingDetailWrap() {
  const {
    shopHandle,
    getBookingDetail,
    bookingTimeModalHandle,
    bookingShopModalHandle,
  } = BookingDetailController();
  const { state } = useBookingDetailContext();
  const {
    detail,
    bookingAddress,
    bookingTimeVisible,
    bookingTime,
    query,
    bookingShopVisible,
    shopId
  } = state;
  const { t } = useTranslation();
  const lang = getI18n().language;

  useEffect(() => {
    getBookingDetail();
  }, []);

  const bookingTimeInputValue = () => {
    if (query.reserveDate && query.reserveTime) {
      return `${query.reserveDate} ${query.reserveTime}`;
    }

    if (query.reserveDate) return query.reserveDate;

    return "";
  };

  const getShopName = () => {
    if (!detail.shopInfoList) return t("请选择预约门店");

    let shopId = query.shopId;
    let shopInfoList = detail.shopInfoList;
    let res = shopInfoList.find((shop) => shop.shopId === shopId);

    return res?.shopName || t("请选择预约门店");
  };
  getShopName();

  return (
    <>
      <div className="relative w-[1080px] mx-auto my-0 mdmax:hidden pb-[50px]">
        <div
          className="bg-white flex relative z-10
                        px-[20px] py-[60px] pr-[90px] mb-[15px] w-[1080px]"
        >
          <div className="flex-1">
            <img src={detail.mainPicView} width="100%" />
          </div>
          <div className="flex-1 ml-[8%] text-center">
            <h1 className="text-[24px] mb-[50px] font-bold text-left pl-[24px]">
              {lang === 'en'? detail.titleEn: detail.title}
            </h1>
            <h1 className="text-[24px] mb-[50px] font-bold text-left pl-[24px]">
              {t("预约信息")}
            </h1>
            <div className="relative flex items-center mb-[20px]">
              <label className="pr-[12px] flex-none w-[120px]">
                {t("预约时间")}
              </label>
              <input
                type="text"
                readOnly
                onClick={() => bookingTimeModalHandle(true)}
                placeholder={t("请选择预约时间")}
                value={bookingTimeInputValue()}
                className="bg-[#f4f4f6] text-[14px] cursor-pointer w-[100%] p-[15px] rounded-[5px]"
              />
              <i className="absolute right-[9px] top-[16px] mdmax:hidden">
                <svg
                  height="20"
                  width="20"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                  focusable="false"
                  className="css-tj5bde-Svg"
                >
                  <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                </svg>
              </i>
            </div>

            <div className="flex items-center mb-[20px]">
              <label className="pr-[12px] flex-none w-[120px]">
                {t("预约门店")}
              </label>
              <div className="flex-1">
                <Select
                  placeholder={t("请选择预约门店")}
                  options={detail.shopInfoList}
                  onChange={shopHandle}
                  controlStyle={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "#f4f4f6",
                    borderRadius: 5,
                    marginBottom: 0,
                  }}
                  value={shopId}
                  keyValue={{
                    label: lang === "en" ? "shopNameEn" : "shopName",
                    value: "shopId",
                  }}
                />
              </div>
            </div>

            <div className="relative flex mb-[40px]">
              <label className="pr-[12px] flex-none w-[120px]">
                {t("预约地址")}
              </label>
              <textarea
                readOnly
                placeholder={t("预约地址")}
                value={bookingAddress}
                className="bg-[#f4f4f6] text-[14px] p-[15px] w-[100%] rounded-[5px] cursor-not-allowed h-[120px]"
              />
            </div>
            <div className="relative flex items-center">
              <label className="pr-[12px] flex-none w-[120px]"></label>
              <AddBookingButton className="rounded-[3px] bg-[#333] text-white text-[16px] w-[100%] py-[15px]" />
            </div>
          </div>
        </div>
        <div className="bg-white py-[28px] px-[34px]">
          <p className="text-[18px] font-bold mb-[15px]">{t("服务详情")}</p>
          <section
            className="container text-[14px]"
            dangerouslySetInnerHTML={{
              __html: lang === "en" ? detail.reserveDescEn : detail.reserveDesc,
            }}
          ></section>
        </div>
      </div>

      <BookingTimeModal
        visible={bookingTimeVisible}
        detail={detail}
        query={query}
        bookingTime={bookingTime}
        handle={bookingTimeModalHandle}
      />

      <div className="md:hidden">
        <Navigator.container>
          <ImgsSwiper img={detail.mainPicView} />
          <div
            className={`bg-white md:hidden relative z-10 top-[40vh] rounded-t-[30px] pt-[22px]`}
          >
            <p className="font-bold text-[16px] px-[18px] mb-[5px]">
              {detail.title}
            </p>
            <div className="divide-y divide-[#DFDFDF] px-[18px] ">
              <div
                className="flex justify-between py-[15px]"
                onClick={() => bookingShopModalHandle(true)}
              >
                <p className="text-[13px] w-[120px]">{t("预约门店")}</p>
                <p className="text-[13px] text-[#999]">{getShopName()}</p>
              </div>
              <div
                className="flex justify-between py-[15px]"
                onClick={() => bookingTimeModalHandle(true)}
              >
                <p className="text-[13px] w-[120px] flex-none">
                  {t("预约时间")}
                </p>
                <p className="text-[13px] text-[#999]">
                  {bookingTimeInputValue() || t("请选择预约时间")}
                </p>
              </div>
              <div className="flex justify-between py-[15px]">
                <p className="text-[13px] w-[120px]">{t("预约地址")}</p>
                <p className="text-[13px] text-[#999]">
                  {bookingAddress || t("请选择预约门店")}
                </p>
              </div>
            </div>
            <WhiteSpec />
            <div className="px-[15px]">
              <p className="font-bold text-[16px] my-[18px]">{t("服务详情")}</p>
              <div
                className="text-[14px]"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "en" ? detail.reserveDescEn : detail.reserveDesc,
                }}
              ></div>
            </div>
            <div className="text-right py-[12px] pt-[20px]">
              <AddBookingButton className="bg-[#ECBC40] font-bold py-[12px] text-[14px] w-[70%] rounded-l-full" />
            </div>
          </div>
        </Navigator.container>
        <WhiteSpec />
        <div className="mx-[3%] pb-[70px] mdmax:hidden">
          <p className="font-bold text-[16px] my-[18px]">{t("服务详情")}</p>
          <div
            dangerouslySetInnerHTML={{
              __html: lang === "en" ? detail.reserveDescEn : detail.reserveDesc,
            }}
          ></div>
        </div>
        <FixedBar>
          <AddBookingButton className="bg-[#333] py-[12px] text-[14px] text-white container rounded-full" />
        </FixedBar>
      </div>
      {/* h5 预约门店actionSheet Select */}
      <Modal
        visible={bookingShopVisible}
        title="请选择预约门店"
        onClose={bookingShopModalHandle}
      >
        <div className="divide-y divide-[#eee] px-[12px]">
          {detail.shopInfoList &&
            detail.shopInfoList.map((shop, i) => {
              const isChecked = shop.shopId === query.shopId;
              return (
                <div
                  className="flex items-center justify-between px-[5px]"
                  onClick={() => {
                    shopHandle(shop);
                    bookingShopModalHandle(false);
                  }}
                  key={i}
                >
                  <p className="text-[13px] text-[#666] py-[12px]">
                    {shop.shopName}
                  </p>
                  <Radio checked={isChecked} />
                </div>
              );
            })}
        </div>
      </Modal>
    </>
  );
}

export default function BookingDetail() {
  return (
    <div className="md:min-h-[100vh]">
      <HeaderMall9 />
      <Navigator title="预约详情" goback backgroundColor={"transparent"} />
      <BookingDetailContext>
        <BookingDetailWrap />
      </BookingDetailContext>
    </div>
  );
}
